// @ts-strict-ignore
import { Injectable } from '@angular/core';
import { CodingArticleProcessor } from './coding-article.processor';
import { ArticleUsageVO } from '@article/model/vo/article.vo';
import { ArticleContainer } from '@3d-scene/model3d/article-container';

@Injectable({ providedIn: 'root' })
export class CodingArticleProcessorDelegator {
    private _codingArticleProcessor: CodingArticleProcessor;

    public get articleCreationManager () {
        return this._codingArticleProcessor.articleCreationManager;
    }

    public set enableCodingFingerAttachedHandler(value: boolean) {
        this._codingArticleProcessor.enableCodingFingerAttachedHandler = value
    }

    public set codingArticleProcessor (value: CodingArticleProcessor) {
        this._codingArticleProcessor = value;
    }

    public findCodingFingerUsageIdByParent(parentArticleUsage: ArticleUsageVO, position: number = 1): string {
        return this._codingArticleProcessor.findCodingFingerUsageIdByParent(parentArticleUsage, position);
    }

    public clean(): void {
        this._codingArticleProcessor.clean();
    }

    public getCreatedArticleContainers(): ArticleContainer[] {
        return this._codingArticleProcessor.getCreatedArticleContainers();
    }
}
